
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ExplainSectionLayout',
  setup() {
    return {
      baseClass: 'epb-explain-section-layout',
    }
  },
})
